import React, { Component } from 'react';

import Loader from '../components/Loader';
import { PersonalLoc } from '../loc/personal';
import { loc } from '../lib/loc';
import { H4 } from '../components/Header';

import * as Api from '../lib/api';

export default class PersonalManager extends Component {
    constructor(props) {
        super(props);

        this.state = {
            data: null,
        };
    }

    componentDidMount() {
        Api.fetch('user/manager')
            .then(data => this.setState({ data: data.success ? data.result : false }))
            .catch(data => this.setState({ data: false }));
    }

    componentDidUpdate(prevProps) {
        if (prevProps.type !== this.props.type) {
            this.forceUpdate();
        }
    }

    renderPhoto(width) {
        const {
            data: { PERSONAL_PHOTO },
        } = this.state;

        return (
            <div className="profile-card__wrap-photo">
                <img style={{ width, height: width }} className="profile-card__photo" src={PERSONAL_PHOTO} alt="" role="presentation" />
            </div>
        );
    }

    renderContacts() {
        const {
            data: { PERSONAL_PHONE, NAME, UF_SKYPE },
        } = this.state;

        const { type } = this.props;

        return (
            <>
                <div className="profile-card__name" style={{ textAlign: type === 'inline' ? 'left' : 'center' }}>
                    {loc(NAME)}
                </div>
                <div className="profile-card__phone">
                    <div className="profile-card__wrap-icon">
                        <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M12.824 16.9926C12.9057 16.9963 12.9837 17 13.0654 17C13.9384 17 14.6666 16.6853 15.2387 16.0671C15.2424 16.0634 15.2498 16.056 15.2535 16.0523C15.4578 15.8079 15.6882 15.5858 15.9334 15.3526C16.1005 15.1934 16.2714 15.0305 16.4311 14.8602C17.1927 14.0679 17.189 13.0647 16.4237 12.302L14.3062 10.1919C13.9422 9.81424 13.5075 9.61433 13.0469 9.61433C12.5899 9.61433 12.1516 9.81054 11.7764 10.1845L10.5244 11.4321C10.413 11.3691 10.2978 11.3136 10.1864 11.2581C10.0452 11.1877 9.9152 11.1211 9.80004 11.0507C8.65213 10.3251 7.61196 9.3774 6.61636 8.15941C6.11485 7.53005 5.78422 7.00436 5.55018 6.46385C5.8771 6.16768 6.18172 5.86041 6.4752 5.56054C6.58293 5.45318 6.69066 5.34212 6.80211 5.23105C7.5971 4.43881 7.5971 3.45775 6.80211 2.66921L5.75079 1.62152C5.6282 1.49935 5.50932 1.37718 5.39044 1.25871C5.1564 1.02178 4.91493 0.773737 4.67346 0.551611C4.3094 0.188807 3.87847 0 3.42154 0C2.96832 0 2.52996 0.188807 2.15104 0.551611L0.832251 1.86215C0.349313 2.34342 0.0744095 2.92835 0.014971 3.60584C-0.0518974 4.44991 0.104129 5.34582 0.505339 6.42683C1.12573 8.09647 2.05817 9.64765 3.44012 11.3062C5.12297 13.3053 7.14388 14.8861 9.45455 16.0004C10.335 16.4188 11.5126 16.9074 12.824 16.9926ZM4.14223 10.725C2.82716 9.14787 1.94672 7.68184 1.36348 6.11215C1.00314 5.14591 0.8694 4.39438 0.925123 3.67988C0.965987 3.21712 1.1443 2.8321 1.47864 2.50261L2.79001 1.19578C2.99061 1.00327 3.20979 0.90331 3.42526 0.90331C3.63701 0.90331 3.84504 1.00327 4.04565 1.19948C4.27968 1.4179 4.50629 1.64743 4.74405 1.88807C4.86293 2.01024 4.98552 2.13611 5.11182 2.25828L6.16314 3.30597C6.59407 3.73541 6.59407 4.15745 6.16314 4.58689C6.0517 4.69795 5.94025 4.80902 5.83252 4.92008C5.5056 5.24957 5.20098 5.56054 4.86293 5.86041C4.8555 5.86781 4.85178 5.87152 4.84435 5.87892C4.54344 6.17879 4.58802 6.46755 4.66232 6.68227C4.66604 6.69338 4.66975 6.70078 4.67346 6.71189C4.94465 7.36346 5.32729 7.98171 5.91424 8.72213C6.97299 10.0216 8.08747 11.0322 9.32081 11.8134C9.47313 11.9096 9.63287 11.9911 9.78889 12.0688C9.93006 12.1392 10.0601 12.2058 10.1752 12.2761C10.1901 12.2835 10.2012 12.2909 10.2161 12.2983C10.335 12.3576 10.4501 12.3872 10.569 12.3872C10.8625 12.3872 11.0482 12.2021 11.1077 12.1392L12.4265 10.8249C12.6271 10.625 12.8425 10.5213 13.0543 10.5213C13.3143 10.5213 13.5261 10.6842 13.6635 10.8249L15.7885 12.9425C16.3086 13.4608 16.0708 13.9273 15.7773 14.2345C15.6287 14.3937 15.4727 14.5418 15.3092 14.701C15.0603 14.9379 14.804 15.186 14.57 15.4636C14.1688 15.8931 13.6933 16.093 13.0729 16.093C13.0134 16.093 12.9503 16.0893 12.8908 16.0856C11.7355 16.0115 10.6656 15.5636 9.85948 15.1823C7.66025 14.1272 5.73964 12.6278 4.14223 10.725Z"
                                fill="#CC0514"
                            />
                        </svg>
                    </div>
                    <span>{PERSONAL_PHONE || loc(PersonalLoc.notSpecified)}</span>
                </div>
                <div className="profile-card__skype">
                    <div className="profile-card__wrap-icon">
                        <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M10.6313 16.3354C10.2499 16.4003 9.86051 16.4332 9.47386 16.4332C5.69484 16.4332 2.6205 13.3589 2.6205 9.58002C2.6205 9.15065 2.66012 8.72247 2.73831 8.30744C2.76405 8.17082 2.74134 8.0295 2.67414 7.90779C2.36114 7.34108 2.19567 6.69834 2.19567 6.04921C2.19559 3.92425 3.92449 2.19559 6.04961 2.19559C6.37975 2.19559 6.6474 1.92794 6.6474 1.59779C6.6474 1.26765 6.37975 1 6.04961 1C3.26524 1 1 3.265 1 6.04913C1 6.82762 1.18165 7.59925 1.52702 8.29413C1.45919 8.71625 1.42491 9.1477 1.42491 9.57994C1.42491 14.018 5.03567 17.6287 9.47386 17.6287C9.92746 17.6287 10.3843 17.5902 10.8316 17.5141C11.1572 17.4587 11.3761 17.15 11.3208 16.8246C11.2654 16.4991 10.9569 16.2801 10.6313 16.3354Z"
                                fill="#CC0514"
                                stroke="white"
                                strok-width="0.25"
                            />
                            <path
                                d="M17.3972 11.0009C17.4805 10.5314 17.5227 10.0542 17.5227 9.57954C17.5227 5.14119 13.912 1.53027 9.47391 1.53027C9.05601 1.53027 8.6354 1.56279 8.2238 1.62696C7.89756 1.67781 7.67439 1.98348 7.72524 2.30972C7.77609 2.63595 8.08184 2.85921 8.408 2.80828C8.75879 2.7536 9.11746 2.72586 9.47391 2.72586C13.2528 2.72586 16.3271 5.80044 16.3271 9.57954C16.3271 10.039 16.2807 10.5015 16.1893 10.9541C16.164 11.0793 16.1795 11.2094 16.2335 11.3251C16.4719 11.8364 16.5928 12.3834 16.5928 12.9509C16.5928 15.0757 14.864 16.8044 12.7391 16.8044C12.4089 16.8044 12.1413 17.0721 12.1413 17.4022C12.1413 17.7323 12.4089 18 12.7391 18C15.5233 18 17.7884 15.735 17.7884 12.9509C17.7884 12.274 17.6569 11.619 17.3972 11.0009Z"
                                fill="#CC0514"
                                stroke="white"
                                strok-width="0.25"
                            />
                            <path
                                d="M12.5236 10.9391C12.5236 10.5824 12.4535 10.277 12.3155 10.0317C12.1776 9.78633 11.9827 9.58053 11.7361 9.41928C11.4891 9.25955 11.1859 9.12102 10.8347 9.00904C10.4871 8.89737 10.0887 8.79303 9.6512 8.69874C9.30472 8.6188 9.05158 8.55694 8.90029 8.51462C8.74837 8.47269 8.59749 8.41451 8.45139 8.34094C8.30401 8.26705 8.18653 8.17762 8.10172 8.07464C8.01659 7.96999 7.97499 7.84915 7.97499 7.70592C7.97499 7.47462 8.09686 7.28197 8.34793 7.11721C8.5951 6.95517 8.92516 6.87308 9.32879 6.87308C9.77028 6.87308 10.0818 6.94648 10.2812 7.09785C10.4778 7.24785 10.6488 7.45852 10.7887 7.72513C10.9 7.91635 10.9982 8.04667 11.091 8.1286C11.2062 8.23039 11.3761 8.25215 11.4984 8.25215C11.694 8.25215 11.8594 8.18304 11.99 8.04706C12.1208 7.91077 12.187 7.75582 12.187 7.5866C12.187 7.40065 12.1336 7.20744 12.0286 7.01232C11.9241 6.81768 11.7554 6.62838 11.5275 6.45016C11.2998 6.27257 11.0097 6.12798 10.665 6.02038C10.3197 5.91389 9.90515 5.85938 9.43257 5.85938C8.84028 5.85938 8.31812 5.94123 7.88093 6.10328C7.44367 6.26468 7.10444 6.49949 6.87321 6.80094C6.64214 7.10255 6.52474 7.45206 6.52474 7.83943C6.52474 8.24625 6.63577 8.59146 6.85472 8.86588C7.07375 9.13991 7.37416 9.3591 7.74743 9.5178C8.12236 9.67721 8.59247 9.81789 9.14435 9.93602C9.555 10.0218 9.89 10.1048 10.1408 10.1828C10.3874 10.2594 10.5921 10.3725 10.7489 10.5189C10.9052 10.6656 10.9846 10.8589 10.9846 11.0931C10.9846 11.3935 10.8416 11.6365 10.5479 11.8374C10.2584 12.0346 9.87653 12.1346 9.41376 12.1346C9.07716 12.1346 8.80122 12.085 8.59438 11.987C8.38771 11.8892 8.22479 11.7628 8.11033 11.6116C7.99667 11.4611 7.88914 11.2709 7.79039 11.045C7.71012 10.8562 7.61153 10.7112 7.49787 10.615C7.38421 10.5187 7.24313 10.4697 7.07838 10.4697C6.87265 10.4697 6.70798 10.5307 6.57535 10.6558C6.44408 10.7788 6.37744 10.929 6.37744 11.1023C6.37744 11.4005 6.48831 11.7115 6.70671 12.0269C6.92598 12.3429 7.21459 12.5988 7.56474 12.7877C8.05884 13.0497 8.69378 13.1823 9.45329 13.1823C10.0862 13.1823 10.6419 13.085 11.1048 12.8929C11.5669 12.7007 11.9227 12.4313 12.1624 12.0921C12.4019 11.753 12.5236 11.3651 12.5236 10.9391Z"
                                fill="#CC0514"
                                stroke="white"
                                strok-width="0.25"
                            />
                        </svg>
                    </div>
                    <span>{UF_SKYPE || loc(PersonalLoc.notSpecified)}</span>
                </div>
            </>
        );
    }

    renderDataMenu() {
        return (
            <>
                <div className="profile-card__title">{loc(PersonalLoc.leftCol.personalManager)}</div>
                {this.renderPhoto()}
                {this.renderContacts()}
            </>
        );
    }

    renderDataInline() {
        return (
            <div style={{ display: 'flex' }}>
                <div style={{ margin: '15px 30px 15px 15px', display: 'flex' }}>{this.renderPhoto('140px')}</div>
                <div>{this.renderContacts()}</div>
            </div>
        );
    }

    renderManagerNotFound() {
        return (
            <div style={{ display: 'flex', hegiht: '200px' }}>
                <div style={{ margin: 'auto' }}>
                    <H4>{loc(PersonalLoc.leftCol.managerNotFound.title)}</H4>
                    {loc(PersonalLoc.leftCol.managerNotFound.text)}
                </div>
            </div>
        );
    }

    renderData() {
        if (!this.state.data) {
            return this.renderManagerNotFound();
        }

        return this.props.type === 'menu' ? this.renderDataMenu() : this.renderDataInline();
    }

    render() {
        const { data } = this.state;

        return data == null ? <Loader /> : this.renderData();
    }
}

PersonalManager.defaultProps = {
    type: 'menu',
};
